<template>
  <!-- 聊天頁面 -->
  <div class="chat-container">
    <chat-toolbar />
    <chat-body ref="chatBody" />
    <chat-action />
    <chat-message-image-dialog ref="imageDialog" />

    <div v-if="!currentChatId" class="disable-overlap"></div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import ChatAction from './ChatAction';
import ChatBody from './ChatBody';
import ChatToolbar from './ChatToolbar';
import ChatMessageImageDialog from './ChatMessageImageDialog';
import SingleElementIntersectionObserver from '@/lib/single-element-intersection-observer';

export default {
  components: {
    'chat-action': ChatAction,
    'chat-body': ChatBody,
    'chat-toolbar': ChatToolbar,
    'chat-message-image-dialog': ChatMessageImageDialog
  },

  data() {
    return {
      visible: false
    };
  },

  computed: {
    ...mapState('chat', {
      currentChatId: state => state.currentChat.id
    })
  },

  watch: {
    visible(v) {
      if (v) {
        this.reportReadMessage(this.currentChatId);
      }
    }
  },

  mounted() {
    this.$eventBus.$on('chat-message-open-image', this.openMessageImage);
    this.$eventBus.$on('receive-current-chat-message', this.onCurrentChatMessageReceived);

    this._intersectionObserver = new SingleElementIntersectionObserver(this.onIntersecting, {
      threshold: 0.9,
      once: false,
      visibleOnly: false
    });
    this._intersectionObserver.observe(this.$el);
  },

  beforeDestroy() {
    this.$eventBus.$off('chat-message-open-image', this.openMessageImage);
    this.$eventBus.$off('receive-current-chat-message', this.onCurrentChatMessageReceived);
    this._intersectionObserver.disconnect();
  },

  methods: {
    ...mapActions('chat', {
      reportReadMessage: 'reportReadMessage'
    }),

    stickScrollbarToBottom() {
      this.$refs.chatBody.stickScrollbarToBottom();
    },

    openMessageImage(chatMessageDto) {
      this.$refs.imageDialog.open(chatMessageDto);
    },

    onCurrentChatMessageReceived() {
      if (this.visible) {
        this.reportReadMessage(this.currentChatId);
      }
    },

    onIntersecting(entry) {
      // entry.isIntersecting is not reliable, use entry.intersectionRatio instead.
      this.visible = entry.intersectionRatio >= 0.9;
    }
  }
};
</script>

<style lang="stylus" scoped>

.chat-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
  // background-color: lighten($def-bg-color, 70%);
}

.disable-overlap {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0);
  width: 100%;
  height: 100%;
}
</style>

